module.exports = __webpack_public_path__ + "img/shuttle-space.668a27d1.svg";